import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { MessageTrayData } from './message-tray.data';

@Injectable({ providedIn: 'root' })

export class MessageTrayService {

  readonly _data: Subject<any> = new ReplaySubject<MessageTrayData>();
  _onEvent: Observable<any>

  readonly _userContext = new BehaviorSubject<{ userId: string; ccn: string }>({ userId: '', ccn: '' });
  userContext$ = this._userContext.asObservable();

  userId = '';
  ccn = '';

  //custom key for storing in sessionstorage
  readonly storageKey = 'messageTrayData';
  readonly userContextKey = 'messageTrayUserContext';

  constructor() {
    this._onEvent = this._data.asObservable();
    this.restoreSession();
    this.restoreUserContext();
  }

  getMessage(): Observable<MessageTrayData>{
    return this._onEvent;
  }

  getUserContext(): Observable<{ userId: string; ccn: string }> {
    return this.userContext$;
  }

  setMessage(message: MessageTrayData, allowDuplicate?: boolean){
    this.saveToSessionStorage(message, allowDuplicate);
  }

  setUserContext(userId: string, ccn: string) {
    this.userId = userId;
    this.ccn = ccn;
    this._userContext.next({ userId, ccn });
    sessionStorage.setItem(this.userContextKey, JSON.stringify({ userId, ccn }));
  }

  getUserId() {
    return this.userId;
  }

  getCcn() {
    return this.ccn;
  }

  restoreUserContext() {
    // ← new: restore the userId/ccn from sessionStorage if available
    const stored = sessionStorage.getItem(this.userContextKey);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        this.userId = parsed.userId ?? '';
        this.ccn = parsed.ccn ?? '';
        this._userContext.next({ userId: this.userId, ccn: this.ccn });
      } catch (e) {
        console.warn('Failed to parse user context from sessionStorage', e);
      }
    }
  }

  restoreSession() {
    const messages = this.getFromSessionStorage();
    messages.forEach( msg => {
      msg.timestamp = new Date(msg.timestamp);
      this._data.next(msg);
    })
  }

  saveToSessionStorage(message: MessageTrayData, allowDuplicate?: boolean) {
    const messages = this.getFromSessionStorage();
    // avoid duplicating message-tray messages
    const exists = messages.some(msg => JSON.stringify(msg.message) === JSON.stringify(message.message));
    if (!exists || allowDuplicate) {
      this._data.next(message);
      messages.push(message);
      sessionStorage.setItem(this.storageKey, JSON.stringify(messages));
    }
  }

  getFromSessionStorage(): MessageTrayData[] {
    const savedMessages= sessionStorage.getItem(this.storageKey);
    return savedMessages ? JSON.parse(savedMessages) : [];
  }

  deleteFromSessionStorage() {
    sessionStorage.removeItem(this.storageKey);
    sessionStorage.removeItem(this.userContextKey);
  }
}
